<template>
	<div class="traffic-map map-card-wrapper">
		<div class="location-btn">
			<v-btn fab small color="white" @click="getCurrentPosition({inform:true})">
				<v-icon class="grey--text text--darken-4">my_location</v-icon>
			</v-btn>
		</div>
		<GmapMap
			ref="trafficMap"
			:options="gmapoptions"
			:center="{lat:41.325300, lng:19.817992}"
			:zoom="13"
			style="width: 100%; height: 100%;"
		></GmapMap>
		<v-card class="traffic-map-legend">
			<span class="map-legend-title">{{getStateWithParam('measurements_speed')}}</span>
			<div class="map-legend-items">
				<div class="legend-item" style="background-color: #9e1313;">&lt; 20</div>
				<div class="legend-item" style="background-color: #e60000;">&lt; 40</div>
				<div class="legend-item" style="background-color: #f07d02;">40 - 60</div>
				<div class="legend-item" style="background-color: #87cb54;">> 60</div>
			</div>
		</v-card>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
export default {
	name: 'GoogleMapsTraffic',
	data(){
		return {
			gmapoptions: {
				zoomControl: false,
				mapTypeControl: false,
				streetViewControl: false,
				scaleControl: false,
				disableDefaultUi: false,
				fullscreenControl: false,
				gestureHandling: 'greedy'
			},
			myPosition: {lat: '', lng: ''},
			outerMarker: null,
			marker: null
		}
	},
	mounted() {
		let $this = this
		this.$refs.trafficMap.$mapPromise.then((map) => {
			//map.panTo({lat: 1.38, lng: 103.80})
			const trafficLayer = new google.maps.TrafficLayer();
			trafficLayer.setMap(map);
			$this.getCurrentPosition()
			$this.$emit('mapready')
		})
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		async getCurrentPosition(options){
			const alertshown = JSON.parse(localStorage.getItem('locationalerts'))
			const permissions = await native_capacitor.checkLocationPermissions()
			const inform = (options && options.inform) ? options.inform : false
			//console.log(alertshown)
			if (permissions.location === 'granted') {
				this.updatePosition(inform);
			} else if( !alertshown || inform ) {
				// request permissions
				const platform = native_capacitor.Capacitor.getPlatform();
				if (platform === 'web') {
					this.updatePosition(inform);
				} else {
					const confirm = await native_capacitor.showConfirm({
						title: this.getStateWithParam('location_off_title'),
						message: this.getStateWithParam('location_off_message'),
						okButtonTitle: this.getStateWithParam('settings_btn'),
						cancelButtonTitle: this.getStateWithParam('close_btn'),
					})
					if (confirm.value) {
						//console.log('open settings');
						native_capacitor.openAppSettings()
					} else {
						//console.log('Dismissed');
					}
					localStorage.setItem('locationalerts', true)
				}
			}
		},
		updatePosition(inform){
			native_capacitor
			.getCurrentPosition()
			.then(data => {
				this.myPosition.lat = data.coords.latitude
				this.myPosition.lng = data.coords.longitude
				this.setMarkers(this.$refs.trafficMap.$mapObject)
				this.$refs.trafficMap.$mapObject.panTo(this.myPosition);
			})
			.catch(err => {
				let message = this.getStateWithParam('location_off_message')
				if (inform) {
					native_capacitor.showToast({text: message, duration: 'long'})
				} else {
					console.log(message)
				}
			});
		},
		setMarkers(map){
			if (this.marker) {
				this.marker.position = this.myPosition
			} else {
				this.marker = new google.maps.Marker({
					map: map,
					animation: google.maps.Animation.DROP,
					position: this.myPosition,
					icon: require("@/assets/img/new_icons/my_location_2.svg")
				});
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.traffic-map{
	position: relative;
	height: calc(100vh - 305px) !important;
	.traffic-map-legend{
		position: absolute;
		top: 10px;
		left: 50%;
		transform: translateX(-50%);
		margin-bottom: 15px;
		background: white;
		padding: 5px 7px;
		border-radius: 5px;
		background-color: rgba($color: #fff, $alpha: 0.7);
		font-size: 0.8em;
		.map-legend-title{
			font-weight: 700;
		}
		.map-legend-items{
			display: flex;
			margin: 3px -5px 0;
			.legend-item{
				font-size: 0.9em;
				white-space: nowrap;
				padding: 2px 5px;
				width: 55px;
				text-align: center;
				line-height: 1;
				margin: 0 5px;
				flex: 1;
				color: #fff;
			}
		}
	}
	
}
</style>